import { render, staticRenderFns } from "./fileTable.vue?vue&type=template&id=46665503&scoped=true"
import script from "./fileTable.vue?vue&type=script&lang=js"
export * from "./fileTable.vue?vue&type=script&lang=js"
import style0 from "./fileTable.vue?vue&type=style&index=0&id=46665503&prod&lang=scss&scoped=true"
import style1 from "./fileTable.vue?vue&type=style&index=1&id=46665503&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46665503",
  null
  
)

export default component.exports